import { render, staticRenderFns } from "./PromiseGoodsDetail.vue?vue&type=template&id=326cbbe9"
import script from "./PromiseGoodsDetail.vue?vue&type=script&lang=js"
export * from "./PromiseGoodsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports